<!--
 * @Author: hfxie
 * @Date: 2024-06-14 16:39:34
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-07-17 09:25:47
 * @Description: 虚拟列表
-->

<template>
  <div
    class="scroll-list-container infinite-list-container"
    @scroll.passive="scrollEvent($event)"
  >
    <div
      class="infinite-list-phantom"
      :style="getHeight"
    ></div>
    <div
      class="infinite-list"
      ref="content"
    >
      <div
        class="infinite-list-item"
        :class="{
          'list-item-border-bottom': item.borderBottom == true,
        }"
        ref="items"
        v-for="item in visibleData"
        :key="item._id"
      >
        <slot ref="slot" :item="item"></slot>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "VirtualList",
  data() {
    return {
      screenHeight: 100, // 可视区域高度      
      start: 0, // 起始索引      
      end: (this.$store.state.minRowsNum * 2), // 结束索引
    };
  },
  props: {
    // 所有列表数据
    listData: {
      type: Array,
      default: () => [],
    },
    positions: {
      type: Array,
      default: () => [],
    },
    // 单行高度
    estimatedItemSize: {
      type: Number,
      default: () => { return 32; },
    },
    // 缓冲区比例
    bufferScale: {
      type: Number,
      default: 1,
    },
    totalHeight: {
      type: Number,
      default: () => { return 0; },
    },
    scrollTop: {
      type: Number,
      default: () => { return 0; },
    },
  },
  computed: {
    // 可视区域高度
    visibleCount() {
      let activeNum = Math.ceil(this.screenHeight / this.estimatedItemSize);
      activeNum = activeNum < this.$store.state.minRowsNum ? this.$store.state.minRowsNum : activeNum;
      return activeNum;
    },
    aboveCount() {
      return Math.min(this.start, this.bufferScale * this.visibleCount);
    },
    belowCount() {
      return Math.min(
        this.listData.length - this.end,
        this.bufferScale * this.visibleCount,
      );
    },
    visibleData() {
      const start = this.start - this.aboveCount < 0 ? 0 : this.start - this.aboveCount;
      const end = this.end + this.belowCount < 0 ? this.$store.state.minRowsNum : this.end + this.belowCount;
      const visibleArr = this.listData.slice(start, end);
      return visibleArr;
    },
    getHeight() {
      let ganttBgCss = "";
      if (this.totalHeight === 0) {
        ganttBgCss = "";
      } else {
        ganttBgCss = {
          "height": this.totalHeight + "px",
        };
      }
      return ganttBgCss;
    },
  },
  /* mounted() {
    this.screenHeight = this.$el.clientHeight;
    this.start = 0;
    this.end = this.start + this.visibleCount;
  }, */
  beforeUpdate() {
    this.$nextTick(function() {
      if (!this.$refs.items || !this.$refs.items.length) {
        return;
      }
      // 更新真实偏移量
      this.setStartOffset();
    });
  },
  created(){
    console.log("V创建", Date.now());
  },
  mounted(){
    this.screenHeight = this.$el.clientHeight;
    console.log("V渲染", Date.now());
  },
  beforeDestroy(){
    console.log("V销毁");
  },
  methods: {
    // 获取列表起始索引
    getStartIndex(scrollTop = 0) {
      return this.binarySearch(this.positions, scrollTop);
    },
    binarySearch(list, value) {
      if (list instanceof Array && list.length > 0) {
        let start = 0;
        let end = list.length - 1;
        let tempIndex = null;

        while (start <= end) {
          const midIndex = parseInt((start + end) / 2);
          const midValue = list[midIndex]._bottom;
          if (midValue === value) {
            return midIndex + 1;
          } else if (midValue < value) {
            start = midIndex + 1;
          } else if (midValue > value) {
            if (tempIndex === null || tempIndex > midIndex) {
              tempIndex = midIndex;
            }
            end = end - 1;
          }
        }
        return tempIndex;
      } else {
        return -1;
      }
    },
    // 获取当前的偏移量
    setStartOffset() {
      try {
        let startOffset;
        if (this.start >= 1) {
          const size =
            this.positions[this.start]._top -
            (this.positions[this.start - this.aboveCount]
              ? this.positions[this.start - this.aboveCount]._top
              : 0);
          startOffset = this.positions[this.start - 1]._bottom - size;
        } else {
          startOffset = 0;
        }
        if(this.$refs.content){
          this.$refs.content.style.transform = `translate3d(0,${startOffset}px,0)`;
          // console.log("修正偏移量", this.$el.scrollTop, startOffset);
        }
      } catch (error) {
        console.warn(error);
      }
      
    },
    // 滚动事件
    scrollEvent() {
      let scrollTop = this.$el.scrollTop;      
      // 起止索引
      this.start = this.getStartIndex(scrollTop);
      this.end = this.start + this.visibleCount;
      this.setStartOffset();
      scrollTop = null;

    },
  },
};
</script>


<style scoped lang='less'>
.infinite-list-container {
  overflow: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
  height: 100%;
}

.infinite-list-phantom {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  z-index: -1;
}

.infinite-list {
  left: 0;
  right: 0;
  top: 0;
  position: absolute;
}

.infinite-list-item {
  position: relative;
  box-sizing: border-box;
  height: 32px;
  height: var(--row-height, @row-height);
  // border-color: red;
  &.list-item-border-bottom{
    border-bottom: 1px solid var(--borderX-color, #666666);
  }
  &:last-of-type {
    border-bottom: none;
  }
}
.infinite-list{
  &.gantt-outbox-border{
    .infinite-list-item{
      .task-info-row{
        border-left: 1px solid var(--border-color, @cBorder);
      }
    }
  }
}
</style>
